export default "__VITE_ASSET__CeqX9HWd__"